/**
 * system 数据
 */

import useragent from '@finance/useragent'
import cookieKit from '../lib/cookie-kit'
import Cookieid from '../lib/cookieid'
import urlKeyValue from '../lib/url'

// 系统名称
const systemName = (() => {
  if (useragent.isAndroid) {
    return 'android OS'
  } else if (useragent.isIOS) {
    return 'iPhone OS'
  }
  return 'other'
})()

// 系统版本号
const systemVersion = (() => {
  if (useragent.isAndroid || useragent.isIOS) {
    return useragent.os.version
  }
  return 'unknown'
})()

// 设置clientId
const setClientId = () => {
  const clientId = cookieKit.get('clientId')
  clientId && cookieKit.set('lc_clientid', clientId)
}

// 设置subClientId
const setSubClientId = () => {
  const COOKIE_EXPIRE_TIME = 60 * 60 * 24 * 365 * 30 // 30年
  const subClient = cookieKit.get('lc_sub_client')
  const urlSubClient = urlKeyValue('sub_client')
  if (subClient) {
    if (urlSubClient) {
      cookieKit.set('lc_sub_client', urlSubClient, COOKIE_EXPIRE_TIME)
    }
  } else if (urlSubClient) {
    cookieKit.set('lc_sub_client', urlSubClient, COOKIE_EXPIRE_TIME)
  } else {
    let subClientName = ''
    if (useragent.isSuishouji) {
      subClientName = 'suishouji'
    } else if (useragent.isSuiguanjia) {
      subClientName = 'suiguanjia'
    } else if (window.navigator.userAgent.indexOf('ruiloansms') !== -1) { // 瑞贷App
      subClientName = 'ruiloan'
    } else if (useragent.isKaniu) {
      subClientName = 'cardniu'
    } else if (useragent.isYunzhijia) {
      subClientName = 'yunzhijia'
    } else if (useragent.isWechat) {
      subClientName = 'wechat'
    } else if (useragent.isQQ) {
      subClientName = 'qq'
    } else {
      subClientName = 'h5'
    }
    cookieKit.set('lc_sub_client', subClientName, COOKIE_EXPIRE_TIME)
  }
}

// 设置cookieId
const setCookieid = () => {
  if (useragent.isSuiguanjia || useragent.isSuishouji) {
    cookieKit.clear('lc_cookieid')
  } else {
    const cookieid = cookieKit.get('lc_cookieid')
    const COOKIE_EXPIRE_TIME = 60 * 60 * 24 * 365 * 30 // 30年
    if (!cookieid) {
      cookieKit.set('lc_cookieid', new Cookieid().id, COOKIE_EXPIRE_TIME)
    }
  }
}

// 获取 无痕埋点 session id
const getSessionId = () => {
  return new Promise((resolve) => {
    let sessionId = ''
    const suiStatistics = window.suiJSContext && window.suiJSContext.getSuiStatisticsClientContext && window.suiJSContext.getSuiStatisticsClientContext()
    /**
     *  获取session_id
     *  1、当app注入了session_id时候，优先使用app提供的session_id
     *  2、当app没有注入session_id时候，h5模拟生成session_id
     */
    if (!suiStatistics) {
      sessionId = cookieKit.get('__s_s_id') || ''
    } else {
      try {
          const data = JSON.parse(suiStatistics)
          sessionId = data.session_id
        } catch (e) {
          sessionId = cookieKit.get('__s_s_id') || ''
        }
    }
    resolve(sessionId)
  })
}

// 设置
export const setSystemData = () => {
  setClientId()
  setSubClientId()
  setCookieid()
}

// 获取
export const getSystemData = async () => {
  const result = {
    systemName,
    systemVersion,
    clientid: cookieKit.get('lc_clientid') || '',
    subClientid: cookieKit.get('lc_sub_client') || '',
    cookieid: cookieKit.get('lc_cookieid') || '',
    ssjid: cookieKit.get('ssj_id') || '',
    suid: cookieKit.get('ssj_uid') || ''
  }
  const sessionId = await getSessionId()
  result.sessionId = sessionId

  return result
}


export default {
  getSystemData,
  setSystemData
}
